// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"b713e7769b10687f2872","147":"c9d9d4c434214598dcea","251":"b59f32dd1cbe4a1a1770","352":"1f0edb149f10e62a7818","550":"b011e4abbc8967a4f77d"}[chunkId] + ".js";
};